import { combineReducers } from 'redux';

import {
  CouponManagementReducer,
  SubjectManageReducer,
  userReducer,
  loginReducer,
  UIStateReducer,
  SubjectReviewReducer,
  sessionReducer,
  categoryReducer,
  PublisherReducer,
  fileExplorerReducer,
  TranscodingManagerReducer,
  LegalPageReducer,
  DeliveryReducer,
  StudentUpdatesReducer,
  StudentManagementReducer,
  LiveClassesReducer,
  BatchManagemntReducer,
  OfflineClassRoomReducer,
  scholarshipsReducer,
  FinanceReducer,
  ClassroomAttendanceReducer,
  campaignReducer,
  NavigationManagerReducer,
  ScholarshipTypeReducer,
} from 'src/store/reducers';

const rootReducer = combineReducers({
  // SPEC_MCP:REDUCERS
  session: sessionReducer,
  selectedCategory: categoryReducer,
  userState: userReducer,
  loginState: loginReducer,
  subjectManage: SubjectManageReducer,
  couponsState: CouponManagementReducer,
  subjectReview: SubjectReviewReducer,
  publisher: PublisherReducer,
  uiState: UIStateReducer,
  fileExplorerReducer,
  transcodingManager: TranscodingManagerReducer,
  LegalPage: LegalPageReducer,
  deliveryState: DeliveryReducer,
  studentUpdates: StudentUpdatesReducer,
  studentManage: StudentManagementReducer,
  liveClassData: LiveClassesReducer,
  manageBatch: BatchManagemntReducer,
  offlineClassRooms: OfflineClassRoomReducer,
  scholarships: scholarshipsReducer,
  finances: FinanceReducer,
  classroomAttendance: ClassroomAttendanceReducer,
  campaignState: campaignReducer,
  navigationManager: NavigationManagerReducer,
  scholarshipType: ScholarshipTypeReducer,
});

export default rootReducer;
